import API from "../utilities/axiosConfig";
import { SysUser } from "../types/user";

export const getUsers = async (): Promise<SysUser[]> => {
  try {
    const response = await API.get<SysUser[]>("/api/users");
    return response.data;
  } catch (error: any) {
    console.error("Error fetching users:", error);
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const login = async (email: string, password: string): Promise<SysUser> => {
  try {
    const response = await API.post("/api/users/login", { email, password });
    const userData: SysUser = response.data;
    return userData;
  } catch (error: any) {
    console.error("Login failed:", error);
    if (error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const register = async (name: string, email: string, password: string): Promise<void> => {
  try {
    const response = await API.post("/api/users", { name, email, password });
  } catch (error: any) {
    console.error("Registration failed:", error);
    if (error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const updateUserById = async (
  userId: number,
  userData: Partial<SysUser>
): Promise<SysUser> => {
  try {
    const response = await API.put<SysUser>(`/api/users/${userId}`, userData);
    return response.data;
  } catch (error: any) {
    console.error("Error updating user:", error);
    throw new Error(
      error.response?.data?.errors?.[0]?.message || "Failed to update user."
    );
  }
};

export const uploadAvatar = async (file: File, userId: number): Promise<string> => {
  const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
  if (!allowedTypes.includes(file.type)) {
    throw new Error("Only JPG, JPEG, PNG, or GIF images are allowed.");
  }
  const formData = new FormData();
  formData.append("File", file);
  formData.append("FileName", file.name);
  formData.append("Timestamp", new Date().toISOString());
  formData.append("FileSize", file.size.toString());
  formData.append("ContentType", file.type);
  formData.append("UploadType", "1");

  try {
    const response = await API.post(`/api/users/avatar/${userId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (typeof response.data === "string") {
      return response.data;
    }

    throw new Error("Unexpected response format");
  } catch (error: any) {
    console.error("Avatar upload failed:", error);
    if (error.response?.data?.errors?.length) {
      throw new Error(error.response.data.errors[0].message);
    }
    throw new Error("An unexpected error occurred. Please try again.");
  }
};


export const getUserById = async (userId: number): Promise<SysUser> => {
  try {
    const response = await API.get<SysUser>(`/api/users/${userId}`);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching user:", error);
    throw new Error(error.response?.data?.message || "Failed to get user.");
  }
};

export const fetchAvatar = async (userId: number) => {
  try {
    const response = await API.get(`/api/users/avatar/${userId}`);
    return response.data;
  } catch (error: any) {
    console.error("Fetch Avatar failed:", error);
    if (error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};